import * as React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="30563" id="hero" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-[#F8F8F6] px-6 py-24 sm:px-12 lg:px-24">
      <div ref={ref} className={cn("relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        <h1 className="mb-4 font-serif text-3xl font-medium tracking-tight text-[#1A1A2E] sm:text-4xl md:text-5xl">
          Chiropractor in Limassol
        </h1>

        {}
        <Badge variant="outline" className="mb-8 border-[#3B8FD4]/30 bg-[#3B8FD4]/5 px-4 py-1.5 text-sm font-medium tracking-widest text-[#3B8FD4] uppercase backdrop-blur-sm">
          Medical Excellence
        </Badge>

        {}
        <h2 className="mb-8 font-serif text-5xl font-medium leading-tight tracking-tight text-[#1A1A2E] sm:text-6xl md:text-7xl lg:text-8xl">
          Precision Healthcare <br className="hidden md:block" />
          <span className="text-[#3B8FD4]">&</span> Wellness
        </h2>

        {}
        <div className="mb-10 flex max-w-[600px] flex-col gap-6 text-lg leading-relaxed text-[#4A5568] md:text-xl font-sans">
          <p>
            Our state-of-the-art facility in Limassol offers comprehensive 
            diagnostic and therapeutic solutions, tailored to the unique health 
            needs of our Mediterranean community.
          </p>
          <p>
            Combining clinical precision with a patient-first philosophy, we 
            ensure every visitor experiences the highest standards of modern 
            healthcare in a serene and professional environment.
          </p>
        </div>

        {}
        <div className="mt-4">
          <Button asChild size="lg" className="h-14 min-w-[200px] rounded-lg bg-[#3B8FD4] px-8 text-lg font-semibold text-white shadow-lg shadow-[#3B8FD4]/20 transition-all hover:bg-[#3B8FD4]/90 hover:shadow-[#3B8FD4]/30 hover:scale-105">
            <Link to="/ContactPage">Book Limassol Appointment</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.08] bg-[url('https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center mix-blend-multiply" />
    </section>;
}